<template>
    <footer>
        <nav class="navbar navbar-expand-md navbar-dark bg-dark pt-3 pb-4"
             :class="[$route.path === '/support' || $route.path === '/login' ? 'fixed-bottom' : '']">
            <ul class="nav navbar-nav mx-auto">
                <li class="nav-item text-white font-weight-bold">
                    <router-link to="support" class="text-white">Ayuda</router-link>
                    <br><br>
                    Creado por Aplicaciones Paleta
                    <img class="fill-white" src="https://legionanime.xyz/assets/images/lollipop.svg"
                         width="15px">
                </li>
            </ul>
        </nav>
    </footer>
</template>

<script>
    export default {
        name: "navbar",
        data() {
            return {
                query: null,
                showMenu: false,
            }
        },
        methods: {
            searchOnDirectory() {
                this.$router.replace({name: 'directory', query: {keyword: this.query}});
            },
            toggleMenu() {
                this.showMenu = !this.showMenu;
                document.querySelector('#dropdown-menu').style.display = this.showMenu ? 'block' : 'none';
            },
        },
    }
</script>

<style scoped>
    .purple-background {
        background: #673bb7 !important;
    }

    .nav-link,
    .nav-link > span {
        color: snow !important;
    }

    .active {
        font-weight: bold !important;
    }

    #my-nav-dropdown > a.nav-link > span {
        color: snow !important;
    }
</style>
